import RestClient from '../RestClient/RestClient';
import { accountId, brightEdgeApiUrl } from './BrightEdgeApi.config';

// function provided by brightEdge
const getPageUrl = (pageUrl) => {
    let hash = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pageUrl.length; i++) {
        const charCode = pageUrl.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + charCode;
        // eslint-disable-next-line no-bitwise
        hash &= hash; // Convert to 32bit integer
    }
    // if hash is a negative number, remove '-' and append '0' in front
    if (hash < 0) {
        // eslint-disable-next-line prefer-template
        hash = '0' + -hash;
    } else {
        // eslint-disable-next-line prefer-template
        hash = '' + hash;
    }
    return hash;
};

export const getBrightEdgeApi = (payload) => {
    if (!payload?.url) return {};

    const pageUrlHash = getPageUrl(payload?.url);
    const url = `${brightEdgeApiUrl}/${accountId}/${pageUrlHash}`;

    const config = {
        url,
        external: true,
    };

    return RestClient.get(config).then((response) => response?.data);
};

export default getBrightEdgeApi;
